import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const rorePlacesRoutes = [
  {
    path: 'places/contexts',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Place Contexts')
      },
      permissions: ['READ_RORE_PLACE_CONTEXTS']
    },
    children: [
      {
        path: '',
        name: 'rorePlaceContextsList',
        component: wrapLegacyRoute('rorePlaceContextsController', 'list')
      },
      {
        path: 'create',
        name: 'rorePlaceContextCreate',
        component: wrapLegacyRoute('rorePlaceContextsController', 'create')
      },
      {
        path: ':contextId(\\d+)',
        name: 'rorePlaceContextDetails',
        component: wrapLegacyRoute('rorePlaceContextsController', 'details')
      }
    ]
  },
  {
    path: 'places',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Places')
      },
      permissions: ['READ_RORE_PLACES']
    },
    children: [
      {
        path: '',
        name: 'rorePlacesList',
        component: wrapLegacyRoute('rorePlacesController', 'list')
      },
      {
        path: 'create',
        name: 'rorePlaceCreate',
        component: wrapLegacyRoute('rorePlacesController', 'create')
      },
      {
        path: ':placeId(\\d+)',
        name: 'rorePlaceDetails',
        component: wrapLegacyRoute('rorePlacesController', 'details')
      }
    ]
  }
];

export default rorePlacesRoutes;
